const oneRoster = 'OneRoster';
const aeries = 'Aeries';
const oneRosterApi = 'OneRosterApiV1';

class OnboardingController {
  constructor(agentDownloadLinkService, $state, agentConfigService) {
    this.agentDownloadLinkService = agentDownloadLinkService;
    this.$state = $state;
    this.agentConfigService = agentConfigService;
    this.getAgentConfig();
  }

  getAgentConfig() {
    this.agentConfigService.getAgentConfig().then(
      this.onGetAgentConfigSuccess.bind(this),
      this.onGetAgentConfigFailure.bind(this)
    );
  }

  onGetAgentConfigSuccess(response) {
    this.agentConfig = response.data.content;
  }

  onGetAgentConfigFailure() {
    console.log('Your account was configured incorrectly. Please contact customer support to fix this');
  }

  isAeriesCustomer() {
    return (this.agentConfig && this.agentConfig.format === aeries);
  }

  isOneRosterCustomer() {
    return (this.agentConfig && this.agentConfig.format === oneRoster);
  }

  isOneRosterApiCustomer() {
    return (this.agentConfig && this.agentConfig.format === oneRosterApi);
  }

  jumpToSecureUpload() {
    this.$state.go('home.syncSettings', {
      tabName: 'uploadFile'
    });
  }

  jumpToSecureAeriesConnection() {
    this.$state.go('home.syncSettings', {
      tabName: 'aeriesConnection'
    });
  }

  jumpToOneRosterApiConnection() {
    this.$state.go('home.syncSettings', {
      tabName: 'oneRosterApi'
    });
  }
}

OnboardingController.$inject = ['agentDownloadLinkService', '$state', 'agentConfigService'];

export default OnboardingController;



// WEBPACK FOOTER //
// ./app/components/onboarding/onboarding.controller.js